// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1xnXL","info":"Note_info__2hihQ","note":"Note_note___AgDD","actions":"Note_actions__Bzz3k"};